import { Component, OnInit } from '@angular/core';
import { CongresosService } from '../../services/services.index';
import { Congreso } from '../../models/congreso.model';

import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
const swal: SweetAlert = _swal as any;

declare var $;

@Component({
  selector: 'app-congresos',
  templateUrl: './congresos.component.html',
  styles: []
})
export class CongresosComponent implements OnInit {

  totalRegistros: number;
  desde: number = 0;
  congresos: Congreso[] = [];
  siguienteDisable: boolean = false;
  anteriorDisable: boolean = true;

  loading: boolean = true;

  constructor(public _congresosService: CongresosService) { }

  ngOnInit() {
    this.cargarCongresos();
    $(document).ready(function() {
      $('body').tooltip({ selector: '[data-toggle=tooltip]' });
  });
  }

  buscarCongreso(termino: string) {
    if (termino.length === 0) {
      this.cargarCongresos();
      return;
    }

    this._congresosService.buscarCongreso(termino).subscribe((resp: any) => {
      this.congresos = resp.congresos;
      this.totalRegistros = resp.total;
    });
  }

  cargarCongresos() {
    this.loading = true;
    this._congresosService.getCongresos(this.desde).subscribe((data: any) => {

      this.congresos = data.congresos;
      this.totalRegistros = data.total;
      this.loading = false;

      // Habilito/inhabilito boton de siguiente.
      if ((this.desde + 5) >= this.totalRegistros) {
        this.siguienteDisable = true;
      } else {
        this.siguienteDisable = false;
      }
    });
  }

  siguienteCongresos() {

    this.desde = this.desde + 5;
    this.cargarCongresos();

    if ((this.desde + 5) >= this.totalRegistros) {
      this.siguienteDisable = true;
    }

    if ((this.desde - 5) < 0) {
      this.anteriorDisable = true;
    } else {
      this.anteriorDisable = false;
    }
  }

  anteriorCongresos() {

    this.desde -= 5;
    this.cargarCongresos();

    if ((this.desde - 5) <= 0) {
      this.anteriorDisable = true;
    }
    if ((this.desde + 5) >= this.totalRegistros) {
      this.siguienteDisable = true;
    } else {
      this.siguienteDisable = false;
    }

  }

  borrarCongreso( congreso: Congreso, i: number ) {
    this.loading = true;
    $('#borrarTooltip_' + i).tooltip('hide');
    this._congresosService.borrarCongreso(congreso).subscribe(resp => {
      swal('Congreso borrado', 'Congreso borrado satisfactoriamente.', 'success');
      this.loading = false;
      this.cargarCongresos();
    });
  }

  editarCongreso(i: number) {
    $('#editarTooltip_' + i).tooltip('hide');
  }

  verCongreso(i: number) {
    $('#verTooltip_' + i).tooltip('hide');
  }

  getDate(timestamp: number) {
    return new Date(timestamp);
  }

  activarCongreso(congreso: Congreso, i: number) {
    this.loading = true;
    $('#activarTooltip_' + i).tooltip('hide');
    this._congresosService.activarCongreso(congreso).subscribe(resp => {
      swal('Congreso activado', 'Congreso avtivado satisfactoriamente.', 'success');
      this.loading = false;
      this.cargarCongresos();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/congresos/congresos.component.ts